module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileselector",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileSelected
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edit_project_name),
      expression: "!edit_project_name"
    }],
    on: {
      "click": _vm.editTitle
    }
  }, [_vm._v(" PROJECT:\n            "), _c('span', [_vm._v(_vm._s(this.$store.state.project.project_name))]), _vm._v(" "), (this.$store.state.project.project_name === '') ? _c('span', {
    staticClass: "tag is-danger is-small"
  }, [_vm._v("NO PROJECT NAME")]) : _vm._e()])]), _vm._v(" "), (_vm.edit_project_name) ? _c('div', {
    staticClass: "nav-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control has-addons"
  }, [_c('button', {
    staticClass: "button is-small is-outlined",
    on: {
      "click": _vm.editTitleCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_project_name),
      expression: "temp_project_name"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.temp_project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_project_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-success is-outlined",
    on: {
      "click": _vm.editTitleUpdate
    }
  }, [_vm._m(1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('tooltip', {
    attrs: {
      "label": this.$store.state.project.local_save_working ? 'Autosave successful' : 'Autosave failing',
      "placement": "left"
    }
  }, [_c('span', {
    staticClass: "icon is-small",
    style: ({
      color: this.$store.state.project.local_save_working ? '#00d1b2' : '#ff3860'
    })
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-item button is-small",
    on: {
      "click": _vm.loadStateFile
    }
  }, [_vm._m(2), _vm._v(" \n            LOAD FROM FILE\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "nav-item button is-small",
    on: {
      "click": _vm.saveStateFile
    }
  }, [_vm._m(3), _vm._v(" \n            SAVE TO FILE\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("Edit Project Name:   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a7eb4ab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 64
// module chunks = 4